"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SCORING_REASON_CODES = void 0;
exports.SCORING_REASON_CODES = [
    'inforce_minimum_met',
    'inforce_minimum_not_met',
    'inforce_minimum_missing',
    'out_of_surrender',
    'in_surrender',
    'surrender_status_missing',
    'client_age_within_limit',
    'client_age_above_limit',
    'client_age_missing',
    'surrender_loss_within_tolerance',
    'surrender_loss_above_tolerance',
    'surrender_loss_missing',
    'account_value_meets_minimum',
    'account_value_below_minimum',
    'account_value_missing',
    'income_track',
    'accumulation_track',
    'income_value_present',
    'income_value_missing',
    'meets_score_threshold',
    'below_score_threshold',
];
//# sourceMappingURL=scoring-rules.js.map